import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { actions } from "../../redux-store";
import { useDispatch } from "react-redux";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    addIcon: {
      fontSize: "2.5rem",
    },
    addMerchant: {
      width: "100%",
      height: "100%",
      display: "flex",
      minHeight: 300,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "transparent",
      cursor: "pointer",
      border: "2px dashed black",
      transition: "0.3s",
      [theme.breakpoints.down("xs")]: {
        minHeight: "unset",
      },
      "&:hover": {
        backgroundColor: "white",
        border: `2px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
      },
    },
    cardHeight: {
      [theme.breakpoints.down("sm")]: {
        height: "28vh",
      },
    },
    titleDivider: {
      alignSelf: "center",
      borderRadius: "2px",
      margin: "10px 0 15px 0",
    },
    img: {
      borderBottom: "1px solid black",
      [theme.breakpoints.down("sm")]: {
        height: "60px",
      },
    },
    title: {
      fontWeight: "bold",
    },
    date: {
      fontWeight: "bold",
      fontSize: 12,
    },
    iconButtonText: {
      marginRight: "1em",
    },
    cardContent: {
      paddingBottom: "0!important",
    },
    cardActions: {
      margin: "10px 0",
    },
    buttonAdd: {
      width: "10px",
      height: "40px",
      position: "absolute",
      right: 60,
      [theme.breakpoints.up("lg")]: {
        right: 150,
      },
    },
  }),
);

const useDefaultEventCard = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      cardContent: {
        root: styles.cardContent,
      },
      actions: {
        root: styles.cardActions,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const dispatch = useDispatch();
  const handleCreateDefaultEventDialogOpen = useCallback(() => {
    dispatch(actions.setIsCreateDefaultEventDialogOpen(true));
  }, [dispatch]);

  const [t] = useTypedTranslations();

  return {
    styles,
    classes,
    atomicStyles,
    handleCreateDefaultEventDialogOpen,
    t,
  };
};

export { useDefaultEventCard as default };
